module.exports = __webpack_public_path__ + "media/newstyle/images/icon-play-6aed39a95af8dce890e72470faf8fa74.svg";